// @ts-strict-ignore
import { Select } from '@/shared/ui'

import {
	getPartialTradeInFilterParams,
	getTradeInSelectOptions,
	isTradeInSelectEnabled,
	TProperties,
	useGetCategoriesQuery
} from '../api/trade-in-slice'

interface TradeInPropertySelectProps {
	property: TProperties
	index: number
	sortedProperties: TProperties[]
	values: Record<string, string> | null
	category: string
	onChange: (option: string) => void
	className?: string
}

export const TradeInPropertySelect = ({
	property,
	index,
	sortedProperties,
	values,
	category,
	onChange,
	className
}: TradeInPropertySelectProps): JSX.Element => {
	const partialParams = getPartialTradeInFilterParams(sortedProperties, values, index)

	// Запрос опций только когда все предыдущие шаги заполнены (или это первый шаг)
	const canFetchOptions =
		index === 0 || sortedProperties.slice(0, index).every(prevProperty => values?.[prevProperty.CODE])

	// Для первого шага опции уже есть в `property` (полный список из запроса калькулятора) —
	// не дублируем тот же запрос без фильтра.
	const { data: categoriesForOptions, isLoading } = useGetCategoriesQuery(
		{ category, params: partialParams },
		{ skip: !canFetchOptions || index === 0 }
	)

	const propertyForOptions = categoriesForOptions?.find(item => item.CODE === property.CODE) ?? property

	return (
		<Select
			onChange={onChange}
			value={values?.[property.CODE] || ''}
			placeholder={property.NAME}
			className={className}
			disabled={!isTradeInSelectEnabled(property, index, sortedProperties, values) || isLoading}
			options={getTradeInSelectOptions(propertyForOptions, index, values)}
		/>
	)
}
